
// src/actions/templates.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_DIARY_TEMPLATES = "FETCH_DIARY_TEMPLATES"
export const FETCH_DIARY_TEMPLATES_REQUESTED = "FETCH_DIARY_TEMPLATES_REQUESTED"
export const FETCH_DIARY_TEMPLATES_COMPLETED = "FETCH_DIARY_TEMPLATES_COMPLETED"
export const FETCH_DIARY_TEMPLATES_FAILED = "FETCH_DIARY_TEMPLATES_FAILED"

export function fetchDiaryTemplatesRequested() {
  return {
    type: FETCH_DIARY_TEMPLATES_REQUESTED
  }
}

export function fetchDiaryTemplates(group_id, user_id) {
  return function(dispatch) {
    dispatch(fetchDiaryTemplatesRequested())
    return api.get(`/templates`, { group_id, user_id, with_last_diary: true, with_organizational: true })
        .then((results)=> {
          dispatch(fetchDiaryTemplatesCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDiaryTemplatesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDiaryTemplatesCompleted(results) {
  return {
    type: FETCH_DIARY_TEMPLATES_COMPLETED,
    results,
  }
}

export function fetchDiaryTemplatesFailed(error) {
  return {
    type: FETCH_DIARY_TEMPLATES_FAILED,
    error,
  }
}

export const FETCH_TEMPLATES = "FETCH_TEMPLATES"
export const FETCH_TEMPLATES_REQUESTED = "FETCH_TEMPLATES_REQUESTED"
export const FETCH_TEMPLATES_COMPLETED = "FETCH_TEMPLATES_COMPLETED"
export const FETCH_TEMPLATES_FAILED = "FETCH_TEMPLATES_FAILED"

export function fetchTemplatesRequested() {
  return {
    type: FETCH_TEMPLATES_REQUESTED
  }
}

export function fetchTemplates(id, type) {
  return function(dispatch) {
    dispatch(fetchTemplatesRequested())
    return api.get(`/templates`, { [type + '_id']: id })
        .then((results)=> {
          dispatch(fetchTemplatesCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchTemplatesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchTemplatesCompleted(results) {
  return {
    type: FETCH_TEMPLATES_COMPLETED,
    results,
  }
}

export function fetchTemplatesFailed(error) {
  return {
    type: FETCH_TEMPLATES_FAILED,
    error,
  }
}

export const FETCH_TEMPLATE_LIST = "FETCH_TEMPLATE_LIST"
export const FETCH_TEMPLATE_LIST_REQUESTED = "FETCH_TEMPLATE_LIST_REQUESTED"
export const FETCH_TEMPLATE_LIST_COMPLETED = "FETCH_TEMPLATE_LIST_COMPLETED"
export const FETCH_TEMPLATE_LIST_FAILED = "FETCH_TEMPLATE_LIST_FAILED"

export function fetchTemplateListRequested() {
  return {
    type: FETCH_TEMPLATE_LIST_REQUESTED
  }
}

export function fetchTemplateList(id, type) {
  return function(dispatch) {
    dispatch(fetchTemplateListRequested())
    return api.get(`/templates`, { [type + '_id']: id })
        .then((results)=> {
          dispatch(fetchTemplateListCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchTemplateListFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchTemplateListCompleted(results) {
  return {
    type: FETCH_TEMPLATE_LIST_COMPLETED,
    results,
  }
}

export function fetchTemplateListFailed(error) {
  return {
    type: FETCH_TEMPLATE_LIST_FAILED,
    error,
  }
}

export const FETCH_TEMPLATE = "FETCH_TEMPLATE"
export const FETCH_TEMPLATE_REQUESTED = "FETCH_TEMPLATE_REQUESTED"
export const FETCH_TEMPLATE_COMPLETED = "FETCH_TEMPLATE_COMPLETED"
export const FETCH_TEMPLATE_FAILED = "FETCH_TEMPLATE_FAILED"

export function fetchTemplateRequested() {
  return {
    type: FETCH_TEMPLATE_REQUESTED
  }
}

export function fetchTemplate(template_id) {
  return function(dispatch) {
    dispatch(fetchTemplateRequested())
    return api.get(`/templates/${template_id}`, {})
        .then((results)=> {
          dispatch(fetchTemplateCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchTemplateFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchTemplateCompleted(results) {
  return {
    type: FETCH_TEMPLATE_COMPLETED,
    results,
  }
}

export function fetchTemplateFailed(error) {
  return {
    type: FETCH_TEMPLATE_FAILED,
    error,
  }
}

export const CREATE_TEMPLATE = "CREATE_TEMPLATE"
export const CREATE_TEMPLATE_REQUESTED = "CREATE_TEMPLATE_REQUESTED"
export const CREATE_TEMPLATE_COMPLETED = "CREATE_TEMPLATE_COMPLETED"
export const CREATE_TEMPLATE_FAILED = "CREATE_TEMPLATE_FAILED"

export function createTemplateRequested() {
  return {
    type: CREATE_TEMPLATE_REQUESTED
  }
}

export function createTemplate(name, template, id, type, attach_json) {
  return function(dispatch) {
    dispatch(createTemplateRequested())
    return api.post(`/templates`, { name, template, [type + '_id']: id, attach_json })
        .then((results)=> {
          dispatch(createTemplateCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createTemplateFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createTemplateCompleted(results) {
  return {
    type: CREATE_TEMPLATE_COMPLETED,
    results,
  }
}

export function createTemplateFailed(error) {
  return {
    type: CREATE_TEMPLATE_FAILED,
    error,
  }
}

export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE"
export const UPDATE_TEMPLATE_REQUESTED = "UPDATE_TEMPLATE_REQUESTED"
export const UPDATE_TEMPLATE_COMPLETED = "UPDATE_TEMPLATE_COMPLETED"
export const UPDATE_TEMPLATE_FAILED = "UPDATE_TEMPLATE_FAILED"

export function updateTemplateRequested() {
  return {
    type: UPDATE_TEMPLATE_REQUESTED
  }
}

export function updateTemplate(template_id, name, template, attach_json) {
  return function(dispatch) {
    dispatch(updateTemplateRequested())
    return api.put(`/templates/${template_id}`, { name, template, attach_json })
        .then((results)=> {
          dispatch(updateTemplateCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateTemplateFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateTemplateCompleted(results) {
  return {
    type: UPDATE_TEMPLATE_COMPLETED,
    results,
  }
}

export function updateTemplateFailed(error) {
  return {
    type: UPDATE_TEMPLATE_FAILED,
    error,
  }
}

export const DELETE_TEMPLATE = "DELETE_TEMPLATE"
export const DELETE_TEMPLATE_REQUESTED = "DELETE_TEMPLATE_REQUESTED"
export const DELETE_TEMPLATE_COMPLETED = "DELETE_TEMPLATE_COMPLETED"
export const DELETE_TEMPLATE_FAILED = "DELETE_TEMPLATE_FAILED"

export function deleteTemplateRequested() {
  return {
    type: DELETE_TEMPLATE_REQUESTED
  }
}

export function deleteTemplate(template_id) {
  return function(dispatch) {
    dispatch(deleteTemplateRequested())
    return api.delete(`/templates/${template_id}`)
        .then((results)=> {
          dispatch(deleteTemplateCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteTemplateFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteTemplateCompleted(results) {
  return {
    type: DELETE_TEMPLATE_COMPLETED,
    results,
  }
}

export function deleteTemplateFailed(error) {
  return {
    type: DELETE_TEMPLATE_FAILED,
    error,
  }
}

export const FETCH_TEMPLATE_FIELDS = "FETCH_TEMPLATE_FIELDS"
export const FETCH_TEMPLATE_FIELDS_REQUESTED = "FETCH_TEMPLATE_FIELDS_REQUESTED"
export const FETCH_TEMPLATE_FIELDS_COMPLETED = "FETCH_TEMPLATE_FIELDS_COMPLETED"
export const FETCH_TEMPLATE_ALL_FIELDS_COMPLETED = "FETCH_TEMPLATE_ALL_COMPLETED"
export const FETCH_TEMPLATE_FIELDS_FAILED = "FETCH_TEMPLATE_FIELDS_FAILED"

export function fetchTemplateFieldsRequested() {
  return {
    type: FETCH_TEMPLATE_FIELDS_REQUESTED
  }
}

export function fetchTemplateFields(group_id, user_id, isDivision = false) {
  return function(dispatch) {
    dispatch(fetchTemplateFieldsRequested())
    const query = isDivision ? { group_ids: group_id, user_id, with_organizational: true } : { group_id, user_id, with_organizational: true }
    return api.get(`/templates`, query)
        .then((results)=> {
          isDivision ? dispatch(fetchTemplateAllFieldsCompleted(results)) : dispatch(fetchTemplateFieldsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchTemplateFieldsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchTemplateAllFieldsCompleted(results) {
  return {
    type: FETCH_TEMPLATE_ALL_FIELDS_COMPLETED,
    results,
  }
}

export function fetchTemplateFieldsCompleted(results) {
  return {
    type: FETCH_TEMPLATE_FIELDS_COMPLETED,
    results,
  }
}

export function fetchTemplateFieldsFailed(error) {
  return {
    type: FETCH_TEMPLATE_FIELDS_FAILED,
    error,
  }
}

export const CLEAR_TEMPLATES = "CLEAR_TEMPLATES"

export function clearTemplates() {
  return {
    type: CLEAR_TEMPLATES
  }
}

export const CLEAR_DIARY_TEMPLATES = "CLEAR_DIARY_TEMPLATES"

export function clearDiaryTemplates() {
  return {
    type: CLEAR_DIARY_TEMPLATES
  }
}

export const IMPORT_USER_PROFILE_TEMPLATE = "IMPORT_USER_PROFILE_TEMPLATE"
export const IMPORT_USER_PROFILE_TEMPLATE_REQUESTED = "IMPORT_USER_PROFILE_TEMPLATE_REQUESTED"
export const IMPORT_USER_PROFILE_TEMPLATE_COMPLETED = "IMPORT_USER_PROFILE_TEMPLATE_COMPLETED"
export const IMPORT_USER_PROFILE_TEMPLATE_FAILED = "IMPORT_USER_PROFILE_TEMPLATE_FAILED"

export function importUserProfileTemplateRequested() {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_REQUESTED
  }
}


export function importUserProfileTemplate() {
  return function(dispatch) {
    dispatch(importUserProfileTemplateRequested())
    return api.get(`/templates/user_profile`)
        .then((results)=> {
          dispatch(importUserProfileTemplateCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(importUserProfileTemplateFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function importUserProfileTemplateCompleted(results) {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_COMPLETED,
    results,
  }
}

export function importUserProfileTemplateFailed(error) {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_FAILED,
    error,
  }
}

export const CLEAR_USER_PROFILE_TEMPLATE = "CLEAR_USER_PROFILE_TEMPLATE"

export function clearUserProfileTemplate() {
  return {
    type: CLEAR_USER_PROFILE_TEMPLATE
  } 
}


// WEBPACK FOOTER //
// ./src/actions/templates.js